import { Component, ChangeDetectorRef, Output, OnInit, EventEmitter, Input } from '@angular/core';
import { CacheService } from '@delon/cache';
import { _HttpClient } from '@delon/theme';
import { Base64 } from 'js-base64';
import { NzMessageService } from 'ng-zorro-antd/message';
import { IEventEmitter, ISelectItem, IYzbDialogComponent, IYzbListItem } from '../../../model/public-api';

import { deepCopy } from '@delon/util';

@Component({
  selector: 'app-mini-checkin',
  templateUrl: './mini-checkin.component.html',
  styles: [
    `
      .list-hover {
        &:hover {
          background-color: #e6f2ff !important;
        }
      }
      .list_item {
        background-color: #e6f2ff !important;
      }
    `
  ]
})
export class MiniCheckinComponent implements OnInit {
  loading = false;
  @Input() pagination = true;
  @Input() listTitle = ''; // 标题
  @Input()
  get wwx_corp_account(): string {
    return this._wwx_corp_account;
  }
  set wwx_corp_account(wwx_corp_account: string) {
    this._wwx_corp_account = wwx_corp_account;

    if (wwx_corp_account) {
      this.selectedItem = { index: -1, data: null };
      this.real_name = '';
      this.page.p = 1;
      this.getCustomer();
    }
  }

  _wwx_corp_account = ''; //账号

  selectedIndex: number | null = null;

  page: {
    p: number;
    num: number;
    count: number;
  } = {
    p: 1,
    count: 0,
    num: 10
  };
  onDblClick() {}
  dataList: any = [];
  protected selectedItem: ISelectItem | ISelectItem[] = { index: -1, data: null };
  @Input() selectedClassName: string | string[] = 'list_item';
  @Output() readonly selectItemEvent = new EventEmitter();
  selectItem(item: any, index: number): void {
    if ((this.selectedItem as ISelectItem).index == index) {
      return;
    }
    this.selectedItem = {
      index: index,
      data: item
    };

    this.selectItemEvent.emit({
      index: index,
      item: item
    });
  }
  itemClassName(item: IYzbListItem, index: number): string | string[] {
    return index == (this.selectedItem as ISelectItem).index ? this.selectedClassName : '';
  }
  selectRow: { index: number; data: any } | any = null;

  stateList: any = [];
  constructor(
    private http: _HttpClient,
    private msgSrv: NzMessageService,
    private cdr: ChangeDetectorRef,
    public cacheSrv: CacheService
  ) {}
  id = '';
  @Input() type = 1; // 养老方式 0-机构养老;1-居家养老
  wwx_chat_user = '';
  wwx_chat_customer = '';
  ngOnInit(): void {
    this.getData();
  }
  showData: any = [];
  real_name = '';
  onSearchInput($event: IEventEmitter) {
    this.showData = this.dataList.filter((item: any) => {
      if (this.type === 1) {
        return item.real_name.indexOf(($event.target as any).value) >= 0 || item.account.indexOf(($event.target as any).value) >= 0;
      } else if (this.type === 2) {
        return item.name.indexOf(($event.target as any).value) >= 0;
      } else {
        return [];
      }
    });
  }
  seach() {
    this.page.p = 1;
    if (this.type === 1) {
      this.getData();
    } else if (this.type === 2) {
      this.getCustomer();
    }
  }
  getCustomer() {
    this.loading = true;
    const condition: any = {};
    if (this.wwx_chat_customer) {
      condition.wwx_chat_customer = ['wwx_chat_customer', 'like', `%${this.wwx_chat_customer}%`];
    }
    const param = Object.assign(this.page, { condition: Base64.encode(JSON.stringify(condition)) });
    this.http.get(`/hospital/v1/user/wxc_account/${this.wwx_corp_account}/chat_external`, param).subscribe(res => {
      this.loading = false;
      if (res.state === 0) {
        this.page.p = res.msg.curr;
        this.page.count = res.msg.count;
        this.dataList = res.data || [];
        for (const item of res.data || []) {
          if (!item.name) item.name = item.wwx_account_type == '1' ? '匿名成员' : '匿名客户';
          item.avatar_name = item.name[0];
          item.id = item.session_id;
        }
        this.showData = deepCopy(res.data || []);
        this.selectedIndex = null;
        this.cdr.detectChanges();
      } else {
        this.msgSrv.error(res.msg);
      }
    });
  }
  getData(): void {
    if (this.type == 1) {
      this.loading = true;
      const condition: any = {};
      if (this.wwx_chat_user) {
        condition.wwx_chat_user = ['wwx_chat_user', 'like', `%${this.wwx_chat_user}%`];
      }
      const param = Object.assign(this.page, { condition: Base64.encode(JSON.stringify(condition)) });
      this.http.get('/hospital/v1/user/chat', param).subscribe(res => {
        this.loading = false;
        if (res.state === 0) {
          this.page.p = res.msg.curr;
          this.page.count = res.msg.count;
          this.dataList = res.data || [];
          for (const item of res.data || []) {
            if (!item.real_name) item.real_name = '匿名成员';
            item.avatar_name = item.real_name[0];
          }
          this.showData = deepCopy(res.data || []);
          this.cdr.detectChanges();
        } else {
          this.msgSrv.error(res.msg);
        }
      });
    }
    if (this.type == 2) {
    }
  }

  onPageIndexChange(index: number) {
    this.page.p = index;
    this.selectRow = null;
    if (this.type === 1) {
      this.getData();
    } else if (this.type === 2) {
      this.getCustomer();
    }
  }
}
